export default function ({ store }) {
  store.commit('sidebars/asideClose')
}
